import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';

import {Button, Confirm, crudUpdateMany} from 'react-admin';


class BooleanBulkButton extends Component {
    state = {
        isOpen: false
    };

    handleClick = () => {
        this.setState({isOpen: true});
    };

    handleDialogClose = () => {
        this.setState({isOpen: false});
    };


    handleConfirm = () => {
        const {basePath, selectedIds, resource, crudUpdateMany } = this.props;

        console.log("Selected IDS: ", selectedIds, resource);


        this.handleDialogClose();
        return crudUpdateMany(resource, selectedIds, { [this.props.source]: this.props.value}, basePath);

    };

    render() {
        return <Fragment>
            <Button label={this.props.label} onClick={this.handleClick} />
            <Confirm isOpen={this.state.isOpen}
                     title={this.props.label}
                     content={`Are you sure you want to '${this.props.label}' selected
                     ${this.props.selectedIds.length} ${this.props.resource}(s) ?`}
                     onConfirm={this.handleConfirm}
                     onClose={this.handleDialogClose}
                     />
        </Fragment>
    }
}

export const BulkEnableMoviesButton = (props) => (
    <ConnectedBulkButton label={"Enable"} source={"is_enabled"} value={true} {...props}/>
);

export const BulkDisableMoviesButton = (props) => (
    <ConnectedBulkButton label={"Disable"} source={"is_enabled"} value={false} {...props}/>
);

export const BulkFeatureMoviesButton = (props) => (
    <ConnectedBulkButton label={"Make Featured"} source={"is_featured"} value={true} {...props}/>
);
export const BulkUnFeatureMoviesButton = (props) => (
    <ConnectedBulkButton label={"Unfeature"} source={"is_featured"} value={false} {...props}/>
);

const ConnectedBulkButton = connect(null, {crudUpdateMany})(BooleanBulkButton);
export default ConnectedBulkButton;
